import { Transition } from "@uirouter/react";
import { MenuNode, MenuRoute } from "../../components/menu";
import { ChainDTO } from "../../store/chain/models/dto";
import { ChainService } from "../../store/chain/service";
import { CryptoDTO } from "../../store/crypto/models/dto";
import { CryptoService } from "../../store/crypto/service";
import { LeafRole, Or } from "../../utils/and-or-tree";
import { ShellRouteNames } from "../shell/route-names";
import { OnChainAnalysisAll } from "./chain-analysis/all";
import { OnChainAnalysisNew } from "./chain-analysis/new";
import { OnChainAnalysisSingle } from "./chain-analysis/single";
import { AllFraudReport } from "./report-a-scam/all";
import { ReportAScamPage } from "./report-a-scam/new";
import { SingleFraudReport } from "./report-a-scam/single";
import { WalletVerificationPage } from "./wallet-verification";

const names = {
  walletVerifcation: `${ShellRouteNames.shell}.wallet-verifcation`,
  followTheMoney: `${ShellRouteNames.shell}.follow-the-money`,
  reportNew: `${ShellRouteNames.shell}.report-new`,
  reportAll: `${ShellRouteNames.shell}.report-all`,
  reportSingle: `${ShellRouteNames.shell}.report-single`,
  walletReportAll: `${ShellRouteNames.shell}.wallet-report-all`,
  walletReportNew: `${ShellRouteNames.shell}.wallet-report-new`,
  walletReportSingle: `${ShellRouteNames.shell}.wallet-report-single`,
};

const states: MenuRoute[] = [
  {
    name: names.walletVerifcation,
    component: WalletVerificationPage,
    url: "/wallet-verifcation",
    data: {
      title: "wallet-verifcation",
    },
  },
  {
    name: names.reportNew,
    url: "/reports/new",
    component: ReportAScamPage,
    data: {
      title: "report-a-scam",
    },
  },
  {
    name: names.reportAll,
    component: AllFraudReport,
    url: "/reports",
    data: {
      title: "all-issued-scam-reports",
    },
  },
  {
    name: names.reportSingle,
    component: SingleFraudReport,
    url: "/reports/:id",
    data: {
      title: "scam-report-detail",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: [
      {
        token: "id",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().id,
      },
      {
        token: "item",
        deps: ["id"],
        resolveFn: (id: string) =>
          CryptoService.getSingleFraudReport(id).catch((err) => err),
      },
    ],
    redirectTo: (trans: Transition) => {
      // getAsync tells the resolve to load
      let resolvePromise: Promise<
        CryptoDTO.Responses.GetSingleFraudReport.T | Error
      > = trans.injector().getAsync("item");
      return resolvePromise.then((
        err // TODO: maybe redirect to 404
      ) => (err instanceof Error ? names.reportAll : undefined));
    },
  },
  {
    name: names.walletReportNew,
    url: "/chain-analysis/new",
    component: OnChainAnalysisNew,
    data: {
      title: "perform-chain-analysis",
    },
  },
  {
    name: names.walletReportAll,
    component: OnChainAnalysisAll,
    url: "/chain-analysis",
    data: {
      title: "all-chain-analysis-reports",
    },
  },
  {
    name: names.walletReportSingle,
    component: OnChainAnalysisSingle,
    url: "/chain-analysis/:id",
    data: {
      title: "chain-analysis-report-detail",
    },
    params: {
      id: {
        type: "string",
      },
    },
    resolve: [
      {
        token: "id",
        policy: { when: "EAGER" },
        deps: [Transition],
        resolveFn: (trans: Transition) => trans.params().id,
      },
      {
        token: "item",
        deps: ["id"],
        resolveFn: (id: string) =>
          ChainService.getSingleWalletReports(id).catch((err) => err),
      },
    ],
    redirectTo: (trans: Transition) => {
      // getAsync tells the resolve to load
      let resolvePromise: Promise<
        ChainDTO.Responses.GetSingleWalletReports.T | Error
      > = trans.injector().getAsync("item");
      return resolvePromise.then((
        err // TODO: maybe redirect to 404
      ) => (err instanceof Error ? names.walletReportAll : undefined));
    },
  },
];

const sidebar: MenuNode.MenuNode = {
  icon: "blockChainTools",
  title: "blockchain-tools",
  children: [
    {
      icon: "followTheMoney",
      title: "chain-analysis",
      children: [
        {
          icon: "chainAnalysisNew",
          route: states[5],
        },
        {
          icon: "chainAnalysisAll",
          route: states[6],
        },
      ],
    },
    {
      icon: "followMoney",
      route: states[1],
    },
    {
      icon: "reportAScam",
      title: "report-scams",
      children: [
        {
          icon: "scamNew",
          route: states[2],
        },
        {
          icon: "scamAll",
          route: states[3],
        },
      ],
    },
    {
      icon: "walletVerification",
      route: states[0],
      disabled: true,
    },
  ],
  roles: new Or(new LeafRole("ROLE_MERCHANT")),
};

export const BlockchainToolsRoutes = {
  names,
  states,
  sidebar,
};
